import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Placeholder = ({ title, icon }) => {
  return (
    <div className="h-full flex flex-col items-center justify-center p-6 text-center">
      <div className="w-24 h-24 bg-pink-50 rounded-full flex items-center justify-center mb-6">
        <SafeIcon name={icon} className="text-4xl text-pink-400" />
      </div>
      <h2 className="text-2xl font-bold text-gray-800 mb-2">{title}</h2>
      <p className="text-gray-500">This feature is coming soon in the next update. ❤️</p>
    </div>
  );
};

export default Placeholder;